module.exports = __webpack_public_path__ + "img/merbear_strawberry_blue_punch.dbf80e36.png";